const getSubdomain = () => {
  if (process.env.NODE_ENV === "development") return "platform";

  return window.location.host.split(".")[0];
};

export default getSubdomain;
